import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import {
    getDefaultHeightOfPaymentIframe,
    getIdOfPaymentIframe,
    getIdOfPaymentIframeContainer,
    getUrlOfPaymentIframe,
    PaymentIframe,
} from "@qgiv/core-react";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectConfig } from "../../../redux/slices/configSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";

const {
    ENUMS: { DefaultView },
} = constants;

/**
 * @description Unlike the Donation Form and Event Registration, in P2P most of
 * the data that is used to configure the credit card fields comes from CMS
 * instead of from Field Settings.
 * @param {object} props
 * @param {number} props.controlId
 * @returns {React.ReactElement}
 */
const ConnectedPaymentIframe = ({ controlId }) => {
    const config = useSelector(selectConfig);
    const formSettings = useSelector(selectAllFormSettings);
    // Data from CMS needed for credit card fields
    const registrationCheckoutStepControl = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );
    const { QGIV_HOST = "", isCms = false } = config;
    const { id = 0 } = formSettings;
    const { options = {} } = registrationCheckoutStepControl;
    const { general = {} } = options;
    const { showBillingNameField = 0 } = general;

    // Format data for use in helper functions and props
    const hasBillingNameField = !!showBillingNameField;
    const formId = id;
    const originOfPaymentIframe = QGIV_HOST;

    // Get data from helper functions
    const defaultHeightOfPaymentIframe =
        getDefaultHeightOfPaymentIframe(hasBillingNameField);
    const idOfPaymentIframe = getIdOfPaymentIframe();
    const idOfPaymentIframeContainer = getIdOfPaymentIframeContainer();
    const urlOfPaymentIframe = getUrlOfPaymentIframe({
        formId,
        isCms,
        originOfPaymentIframe,
    });

    return (
        <PaymentIframe
            defaultHeightOfPaymentIframe={defaultHeightOfPaymentIframe}
            idOfPaymentIframe={idOfPaymentIframe}
            idOfPaymentIframeContainer={idOfPaymentIframeContainer}
            originOfPaymentIframe={originOfPaymentIframe}
            urlOfPaymentIframe={urlOfPaymentIframe}
        />
    );
};

export default ConnectedPaymentIframe;
